import React from "react";
import styles from "../Pages/Project.module.css";
import {
  Box,
  Center,
  Text,
  Link,
  Image,
  Heading,
  Flex,
} from "@chakra-ui/react";
import KFC from "../img/KFC.png";
import Shop_kro from "../img/Shop_kro.png";
import surveyMoney3 from "../img/surveyMoney3.png";
import wonpluswon from "../img/wonpluswon.png";
import "../Styles/Project.css";
const Project = () => {
   return (
    <div id="Project">
      <Box w="100%" color="#FFFFFF">
        <Center color={"#DC143C"}>
          <Heading as={"h1"} size="xl">
            -Project-
          </Heading>
        </Center>
      </Box>

      <div className={styles.Project}>
        {/* -----------------111111111111------------------------------- */}

        <div className={styles.item}>
          <Box>
            <Image src={KFC} alt="" borderRadius="10px" />
          </Box>
          <Center color={"#DC143C"}>
            <Heading as={"h1"} size="md">
              KFC
            </Heading>
          </Center>
          <Text fontSize="xl" color="#EEE">
            KFC is the online vag non-vag food shaling website ..
          </Text>
          <b style={{ color: "#DC143C" }}>Teach:-</b>{" "}
          <Text fontSize="xl" color="#EEE">
            html5,css3,javascript ,Reactjs,react-router-dom@6
          </Text>
          <b style={{ color: "#DC143C" }}>Responsiblity:-</b>
          <Text fontSize="xl" color="#EEE">
            Navbar,Footer,Menu,Deals,SignIn,Cart,Payment
          </Text>
          <Flex justifyContent="space-around" gap="30px">
            <Link href=" https://my-kfc.vercel.app/" isExternal>
              <Image src={"https://jitsu-13.github.io/Images/Eye.png"} alt="" />
            </Link>

            <Link href="https://github.com/Ashukla011/KFC" isExternal>
              <Image
                src={
                  "https://jitsu-13.github.io/Images/icons8-github-64%20(1).png"
                }
                alt=""
                w="50%"
              />
            </Link>
          </Flex>
        </div>
        {/* -----------------22222222222222222  BlueMercury.com------------------------------- */}

        <div className={styles.item}>
          <Box>
            <Image src={Shop_kro} alt="" borderRadius="10px" />
          </Box>
          <Center color={"#DC143C"}>
            <Heading as={"h1"} size="md">
              Shop Karo.com
            </Heading>
          </Center>
          <Text fontSize="xl" color="#EEE">
            Shop Karo.com is a e-commerce website for buying clothing products
            for mens and womens
          </Text>
          <b style={{ color: "#DC143C" }}>Teach:-</b>{" "}
          <Text fontSize="xl" color="#EEE">
            html5,css3 ,javascript,react.js,node.js,express,mongoDb,chakraUi
          </Text>
          <b style={{ color: "#DC143C" }}>Responsiblity:-</b>
          <Text fontSize={"xl"} color="#EEE">
            Explor,Routen,Blueworld,RuteneRebut
          </Text>
          <Flex justifyContent="space-around" gap="30px">
            <Link href="https://cw-5.vercel.app/" isExternal>
              <Image src={"https://jitsu-13.github.io/Images/Eye.png"} alt="" />
            </Link>
            <Link
              href="https://github.com/Ashukla011/Shop_Karo_Clone"
              isExternal
            >
              <Image
                src={
                  "https://jitsu-13.github.io/Images/icons8-github-64%20(1).png"
                }
                alt=""
                w="50%"
              />
            </Link>
          </Flex>
        </div>

        {/* -----------------333333333333333333 Ayoa------------------------------- */}

        <div className={styles.item}>
          <Box>
            <Image src={wonpluswon} alt="" borderRadius="10px" />
          </Box>
          <Center color={"#DC143C"}>
            <Heading as={"h1"} size="md">
              wonpluswon
            </Heading>
          </Center>
          <Text fontSize="xl" color="#EEE">
            wonpluswon is a amzing affordable learning plateform here you can
            learn by video.
          </Text>
          <b style={{ color: "#DC143C" }}>Teach:-</b>{" "}
          <Text fontSize="xl" color="#EEE">
            javascript,Rect.Js, Next,TypeScript,ChakraUi
          </Text>
          <b style={{ color: "#DC143C" }}>Responsiblity:-</b>
          <Text fontSize="xl" color="#EEE">
            Live page, Demo page
          </Text>
          <Flex justifyContent="space-around" gap="30px">
            <Link href="https://wonpluswon-phi.vercel.app/" isExternal>
              <Image src={"https://jitsu-13.github.io/Images/Eye.png"} alt="" />
            </Link>

            <Link href="https://github.com/Vishal0312/wonpluswon" isExternal>
              <Image
                src={
                  "https://jitsu-13.github.io/Images/icons8-github-64%20(1).png"
                }
                alt=""
                w="50%"
              />
            </Link>
          </Flex>
        </div>

        {/* -----------------4444444444444444 wonpluswon------------------------------- */}

        <div className={styles.item}>
          <Box>
            <Image src={surveyMoney3} alt="" borderRadius="10px" />
          </Box>
          <Center color={"#DC143C"}>
            <Heading as={"h1"} size="md">
              SurveyMonkey
            </Heading>
          </Center>
          <Text fontSize="xl" color="#EEE">
            SurveyMonkey is a online survey website,this is a team project Be
            the person with great ideas. Surveys give you actionable insights
            and fresh perspectives.
          </Text>
          <b style={{ color: "#DC143C" }}>Teach:-</b>{" "}
          <Text fontSize="xl" color="#EEE">
            html5,css3,javascript, react.js,Redux
          </Text>
          <b style={{ color: "#DC143C" }}>Responsiblity:-</b>
          <Text fontSize={"xl"} color="#EEE">
            Home page
          </Text>
          <Flex justifyContent="space-around" gap="30px" margin="auto">
            <Link
              href="https://startling-youtiao-e9d129.netlify.app"
              isExternal
            >
              <Image src={"https://jitsu-13.github.io/Images/Eye.png"} alt="" />
            </Link>
            <Link href="https://github.com/omesh96/Ayoa-Clone" isExternal>
              <Image
                src={
                  "https://jitsu-13.github.io/Images/icons8-github-64%20(1).png"
                }
                alt=""
                w="50%"
              />
            </Link>
          </Flex>
        </div>
      </div>
    </div>
  );
};

export default Project;

// Ayoga :-https://startling-youtiao-e9d129.netlify.app,https://github.com/omesh96/Ayoa-Clone
// MonkeySurvey:-https://roaring-bublanina-916643.netlify.app,https://github.com/Vishaltandale987/woozy-north-6172
//perfect blu mercuty:-https://darling-basbousa-b508b0.netlify.app,https://github.com/Ashukla011/perfect-business-7811
//kalyan:-https://capable-boba-5533c8.netlify.app,https://github.com/Ashukla011/kalyancolne
